import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { NbAuthService, NbAuthJWTToken } from '@nebular/auth';
import { tap, map } from 'rxjs/operators';
import { combineLatest } from 'rxjs';

@Injectable()
export class AuthGuard implements CanActivate {

  constructor(private authService: NbAuthService, private router: Router) { }

  canActivate() {
    return combineLatest([this.authService.isAuthenticatedOrRefresh(), this.authService.getToken()])
      .pipe(
        tap(([authenticated, token] : [boolean, NbAuthJWTToken]) => {
          if (!authenticated) {
            // Not authenticated.
            this.router.navigate(['auth/login']);
          } else if (token.getPayload()['admin'] !== true) {
            // Authenticated but is not admin.
            this.router.navigate(['auth/not-allowed']);
          }
        }),
        map(([authenticated, token] : [boolean, NbAuthJWTToken]) => {
          return authenticated && token.getPayload()['admin'] === true;
        }),
      );
  }

}
